import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../../module/store/gameStore';
import { tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { Matrix } from '../../../../components/matrix';
import { MatrixTypes } from '../../../../enums/GameEnums';
import { TKeys } from '../../../../core/constants/TKeys';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { detectHistoryFieldColors } from '../../../../helpers/detectHistoryFieldColors';

export const SelectedRowWeb = observer(() => {

  const t = useTranslation()
  const { odds } = gameStore
  const { data: thirdStepData } = tableBetHistoryStore.thirdStep;
  const { amount, winAmount, roundData, odd } = thirdStepData
  const { currencySymbolOrCode } = userInfoStore

  const matrixType = useMemo(() => {
    return MatrixTypes.findIndex(el =>  el.row === roundData.length)
  }, [thirdStepData])

  return (
    <div className='bet-history-wrp'>
      <div className='bet-h-result-wrp'>
        <p className='bet-h-result-text'>{t(TKeys.RESULT)}</p>
      </div>
      <div className='bet-history-square-wrp'>
        <div className={`bg m-game-mid-${(MatrixTypes[matrixType].type)}-wrp 'animation-square-wrapper'}`}>
          <Matrix matrixType={matrixType}
                  odds={odds[MatrixTypes[matrixType].enumType]}
                  isHistory={true}
                  fieldsColor={detectHistoryFieldColors(thirdStepData)}
                  matrix={roundData} />
        </div>

      </div>
      <div className='bet-history-table-wrp'>
        <div className='bet-history-table-title-wrp'>
          <div className='bet-history-table-title-clm'><p className='bet-history-table-title-text'>{t(TKeys.Bet)}</p></div>
          <div className='bet-history-table-title-clm'><p className='bet-history-table-title-text'>{t(TKeys.Odd)}</p></div>
          <div className='bet-history-table-title-clm'><p className='bet-history-table-title-text'>{t(TKeys.Win)}</p></div>
        </div>
        <div className='bet-history-table-content-wrp'>
          <div className='bet-history-table-content-row'>
            <div className='bet-h-table-c-clm'><p className='bet-h-table-c-clm-txt'>{amount}{currencySymbolOrCode}</p></div>
            <div className='bet-h-table-c-clm'><p className='bet-h-table-c-clm-txt'>x{odd}</p></div>
            <div className='bet-h-table-c-clm'><p className='bet-h-table-c-clm-txt'>{winAmount}{currencySymbolOrCode}</p></div>
          </div>
        </div>
      </div>
    </div>
  );
})